import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  style: {"text-align":"center"},
  class: "GYONO meisaiCont cwU_1"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  style: {"text-align":"center","position":"relative"},
  class: "CLAIMNO meisaiCont cwU_2"
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["value", "disabled"]
const _hoisted_6 = { class: "CLAIM_DATE meisaiCont cwU_3 disableGray" }
const _hoisted_7 = { class: "SALESMONTH meisaiCont cwU_4 disableGray" }
const _hoisted_8 = {
  style: {"text-align":"left"},
  class: "ITEMIZE meisaiCont cwU_5 selectBorderNone"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  style: {"text-align":"left"},
  class: "COURSE meisaiCont cwU_6"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["value"]
const _hoisted_14 = {
  style: {"text-align":"left"},
  class: "BREAK_DOWN cwU_7"
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  style: {"text-align":"left"},
  class: "SALES_CD meisaiCont cwU_8 selectBorderNone disableGray"
}
const _hoisted_18 = {
  class: "SUM meisaiCont cwU_9",
  id: "Sales_SUM_1",
  style: {"position":"relative"}
}
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  style: {"text-align":"left"},
  class: "SYOHIZEI_RITU meisaiCont cwU_10 selectBorderNone"
}
const _hoisted_21 = ["disabled"]
const _hoisted_22 = ["value", "disabled"]
const _hoisted_23 = { class: "NYUKIN_YOTEI_DATE meisaiCont cwU_11 disableGray" }
const _hoisted_24 = { style: {"padding-left":"10px"} }
const _hoisted_25 = { class: "BIKO meisaiCont cwU_13" }
const _hoisted_26 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Mt_dtp = _resolveComponent("Mt_dtp")!
  const _component_Mt_dtp4month = _resolveComponent("Mt_dtp4month")!
  const _component_vSelect = _resolveComponent("vSelect")!
  const _component_VTooltip = _resolveComponent("VTooltip")!

  return (_openBlock(), _createElementBlock("tr", {
    class: _normalizeClass(["salesrow", { selectedRow: _ctx.item.isSelect }]),
    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.selectRow())),
    onFocusout: _cache[19] || (_cache[19] = ($event: any) => (_ctx.calcProfit()))
  }, [
    _createElementVNode("td", _hoisted_1, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        readonly: "true",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.item.c_sales_rownum) = $event)),
        disabled: 
          _ctx.item.isApprovedClaim == 1 &&
          _ctx.$store.state.authType == _ctx.authtypeNyuryokusya
        
      }, null, 8, _hoisted_2), [
        [_vModelText, _ctx.item.c_sales_rownum]
      ])
    ]),
    _createElementVNode("td", _hoisted_3, [
      (_ctx.item.isApprovedClaim == 1)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: "fal fa-external-link claimLnk",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.linkClaim($event)), ["stop"]))
          }))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("select", {
        class: _normalizeClass({
          selectWithClimlink:
            _ctx.item.isApprovedClaim == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya,
        }),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.item.cnvClaimnumTmp) = $event)),
        disabled: 
          _ctx.item.isApprovedClaim == 1 &&
          _ctx.$store.state.authType == _ctx.authtypeNyuryokusya
        
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.claims, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            value: option.c_claim_number,
            key: option.c_claim_number!,
            disabled: 
            _ctx.item.isApprovedClaim == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya
          ,
            style: {"text-align":"right"}
          }, _toDisplayString(option.c_claim_number), 9, _hoisted_5))
        }), 128))
      ], 10, _hoisted_4), [
        [_vModelSelect, _ctx.item.cnvClaimnumTmp]
      ])
    ]),
    _createElementVNode("td", _hoisted_6, [
      _createVNode(_component_Mt_dtp, {
        contdate: _ctx.item.cnvDateIssue,
        "onUpdate:contdate": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.item.cnvDateIssue) = $event)),
        holidays: _ctx.mastersData,
        "onUpdate:holidays": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.mastersData) = $event)),
        class: "dtpJyutyuBulk jyutyuTable",
        disabled: 
          _ctx.item.isApprovedClaim == 1 &&
          _ctx.$store.state.authType == _ctx.authtypeNyuryokusya
        
      }, null, 8, ["contdate", "holidays", "disabled"])
    ]),
    _createElementVNode("td", _hoisted_7, [
      _createVNode(_component_Mt_dtp4month, {
        contdate: _ctx.item.cnvDateMonth,
        "onUpdate:contdate": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.item.cnvDateMonth) = $event)),
        class: "dtpJyutyuBulk noneBorder",
        minDate: _ctx.getMinDate(),
        disabled: 
          _ctx.item.isApprovedClaim == 1 &&
          _ctx.$store.state.authType == _ctx.authtypeNyuryokusya
        
      }, null, 8, ["contdate", "minDate", "disabled"])
    ]),
    _createElementVNode("td", _hoisted_8, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.item.c_sales_item) = $event)),
        onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.cngItem())),
        disabled: 
          _ctx.item.isApprovedClaim == 1 &&
          _ctx.$store.state.authType == _ctx.authtypeNyuryokusya
        
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.opItemtypeItem, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            value: option.code,
            key: option.code
          }, _toDisplayString(option.label), 9, _hoisted_10))
        }), 128))
      ], 40, _hoisted_9), [
        [_vModelSelect, _ctx.item.c_sales_item]
      ])
    ]),
    _createElementVNode("td", _hoisted_11, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.item.c_sales_subject) = $event)),
        disabled: 
          _ctx.item.isApprovedClaim == 1 &&
          _ctx.$store.state.authType == _ctx.authtypeNyuryokusya
        
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getOpItemtypeSubjects(), (option) => {
          return (_openBlock(), _createElementBlock("option", {
            value: option.code,
            key: option.code
          }, _toDisplayString(option.label), 9, _hoisted_13))
        }), 128))
      ], 8, _hoisted_12), [
        [_vModelSelect, _ctx.item.c_sales_subject]
      ])
    ]),
    _createElementVNode("td", _hoisted_14, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.item.c_sales_breakdown) = $event)),
        disabled: 
          _ctx.item.isApprovedClaim == 1 &&
          _ctx.$store.state.authType == _ctx.authtypeNyuryokusya
        
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getOpItemtypeBreakdown(), (option) => {
          return (_openBlock(), _createElementBlock("option", {
            value: option.code,
            key: option.code
          }, _toDisplayString(option.label), 9, _hoisted_16))
        }), 128))
      ], 8, _hoisted_15), [
        [_vModelSelect, _ctx.item.c_sales_breakdown]
      ])
    ]),
    _createElementVNode("td", _hoisted_17, [
      _createVNode(_component_vSelect, {
        options: _ctx.opClients,
        modelValue: _ctx.item.c_client_id,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.item.c_client_id) = $event)),
        label: "c_client_name",
        reduce: (label) => label.c_client_id,
        disabled: 
          _ctx.item.isApprovedClaim == 1 &&
          _ctx.$store.state.authType == _ctx.authtypeNyuryokusya
        
      }, null, 8, ["options", "modelValue", "reduce", "disabled"])
    ]),
    _createElementVNode("td", _hoisted_18, [
      (_ctx.item.isMissMatch)
        ? (_openBlock(), _createBlock(_component_VTooltip, {
            key: 0,
            class: "isMissMatchIcon"
          }, {
            popper: _withCtx(() => [
              _createTextVNode(" 請求No" + _toDisplayString(_ctx.item.c_sales_climnum_tmp) + "は、申請中または、承認済みですが、売上明細の合計値と、請求書の合計値が一致していません", 1),
              _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
              _createTextVNode(" 請求No" + _toDisplayString(_ctx.item.c_sales_climnum_tmp) + "の税抜き合計金額は、" + _toDisplayString(_ctx.item.subTotal4Claim!.toLocaleString("ja-JP")) + "円です ", 1)
            ]),
            default: _withCtx(() => [
              _cache[21] || (_cache[21] = _createElementVNode("i", { class: "fal fa-info-circle" }, null, -1))
            ]),
            _: 1,
            __: [21]
          }))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: _normalizeClass({ isMissMatch: _ctx.item.isMissMatch }),
        maxlength: "10",
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.item.cnvPrice) = $event)),
        onFocus: _cache[12] || (_cache[12] = ($event: any) => (_ctx.kanmaDel($event))),
        onBlur: _cache[13] || (_cache[13] = ($event: any) => (_ctx.kanmaIns($event))),
        disabled: 
          _ctx.item.isApprovedClaim == 1 &&
          _ctx.$store.state.authType == _ctx.authtypeNyuryokusya
        
      }, null, 42, _hoisted_19), [
        [_vModelText, _ctx.item.cnvPrice]
      ])
    ]),
    _createElementVNode("td", _hoisted_20, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.item.c_sales_taxrate) = $event)),
        disabled: 
          _ctx.item.isApprovedClaim == 1 &&
          _ctx.$store.state.authType == _ctx.authtypeNyuryokusya
        
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.opTaxtate, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            value: option.code,
            key: option.code,
            disabled: 
            _ctx.item.isApprovedClaim == 1 &&
            _ctx.$store.state.authType == _ctx.authtypeNyuryokusya
          
          }, _toDisplayString(option.label), 9, _hoisted_22))
        }), 128))
      ], 8, _hoisted_21), [
        [_vModelSelect, _ctx.item.c_sales_taxrate]
      ])
    ]),
    _createElementVNode("td", _hoisted_23, [
      _createVNode(_component_Mt_dtp, {
        contdate: _ctx.item.cnvDateExpPayment,
        "onUpdate:contdate": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.item.cnvDateExpPayment) = $event)),
        holidays: _ctx.mastersData,
        "onUpdate:holidays": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.mastersData) = $event)),
        class: "dtpJyutyuBulk jyutyuTable",
        disabled: 
          _ctx.item.isApprovedClaim == 1 &&
          _ctx.$store.state.authType == _ctx.authtypeNyuryokusya
        
      }, null, 8, ["contdate", "holidays", "disabled"])
    ]),
    _createElementVNode("td", {
      class: _normalizeClass(["NYUKIN_DATE meisaiCont cwU_12", {
        tdDisables:
          _ctx.item.isApprovedClaim == 1 &&
          _ctx.$store.state.authType == _ctx.authtypeNyuryokusya,
      }])
    }, [
      _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.item.cnvDateCmpPayment.date?.replaceAll("-", "/")), 1)
    ], 2),
    _createElementVNode("td", _hoisted_25, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.item.c_sales_remarks) = $event)),
        disabled: 
          _ctx.item.isApprovedClaim == 1 &&
          _ctx.$store.state.authType == _ctx.authtypeNyuryokusya
        
      }, null, 8, _hoisted_26), [
        [_vModelText, _ctx.item.c_sales_remarks]
      ])
    ])
  ], 34))
}